module.exports = __webpack_public_path__ + "static/media/N11.332ee213.jpg";